import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import Header from "../components/Header";
import LeftNav from "../components/LeftNav";
import UserService from "../services/UserService";

const serverConfig = require("../config/server.js");

const Profile = () => {
  const [token, setToken] = useState(null);
  const [activeSection, setActiveSection] = useState("overview");
  const [userInfo, setUserInfo] = useState({
    name: UserService.getWelcomeName() || "User",
    email: UserService.getUsername() || "user@example.com",
    avatar: (UserService.getWelcomeName() || "U")[0],
  });

  const handleLogout = () => {
    sessionStorage.clear();
    UserService.doLogout();
  };

  const getToken = () => {
    let jwt = UserService.getToken();
    axios.post(serverConfig.api_base_url + "user_sync_from_sso", { jwt: jwt }).catch((error) => {
      console.log("user_sync_from_sso response", error);
    });
    axios
      .post(serverConfig.api_base_url + "user_get_token", { jwt: jwt })
      .then((response) => {
        if (response.data.status === 200) {
          sessionStorage.setItem("token", response.data.token);
          setToken(response.data.token);
        } else if (response.data.status >= 400 && response.data.status <= 499) {
          alert(response.data.message);
        } else if (response.data.jwt_validation === "fail") {
          handleLogout();
        }
      })
      .catch((err) => console.log("error is", err));
  };

  useEffect(() => {
    if (sessionStorage.getItem("token") === null) {
      getToken();
    } else {
      setToken(sessionStorage.getItem("token"));
    }
  }, []);

  return (
    <>
      <LeftNav />
      <div className="main-wrapper">
        <Header token={token} />
        <main style={{ padding: "35px" }}>
          <Container fluid>
            <Row>
              {/* Left Sidebar */}
              <Col lg={3} className="profile-sidebar">
                <div
                  className="profile-sidebar-card"
                  style={{
                    backgroundColor: "#191E27",
                    padding: "20px",
                  }}
                >
                  <div style={{ marginBottom: "20px" }}>
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        border: "1px solid #FD9F29",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#fff",
                        margin: "0 auto",
                        marginBottom: "10px",
                      }}
                    >
                      {userInfo.avatar}
                    </div>
                    <h5
                      style={{
                        textAlign: "center",
                        marginBottom: "5px",
                        color: "#F4F3F2",
                      }}
                    >
                      {userInfo.name}
                    </h5>
                    <p
                      style={{
                        textAlign: "center",
                        color: "#979A9F",
                        fontSize: "12px",
                        margin: 0,
                      }}
                    >
                      {userInfo.email}
                    </p>
                  </div>
                </div>

                {/* Sidebar Navigation */}
                <div
                  className="profile-nav"
                  style={{
                    backgroundColor: "#191E27",
                    overflow: "hidden",
                  }}
                >
                  {[
                    { id: "overview", label: "Overview" },
                    { id: "security", label: "Security info" },
                    { id: "devices", label: "Devices" },
                    { id: "password", label: "Change password" },
                    { id: "organizations", label: "Organizations" },
                    { id: "settings", label: "Settings & Privacy" },
                    { id: "activity", label: "Recent activity" },
                  ].map((item) => (
                    <button
                      key={item.id}
                      onClick={() => setActiveSection(item.id)}
                      style={{
                        width: "100%",
                        padding: "12px 15px",
                        border: "none",
                        background:
                          activeSection === item.id ? "#FD9F29" : "transparent",
                        color:
                          activeSection === item.id ? "#0C1017" : "#F4F3F2",
                        textAlign: "left",
                        fontSize: "14px",
                        cursor: "pointer",
                        borderBottom: "1px solid #3D4045",
                        fontWeight:
                          activeSection === item.id ? "bold" : "normal",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      {item.label}
                    </button>
                  ))}
                  <button
                    onClick={handleLogout}
                    style={{
                      width: "100%",
                      padding: "12px 15px",
                      borderTop: "1px solid #3D4045",
                      borderLeft: "none",
                      borderRight: "none",
                      borderBottom: "none",
                      background: "transparent",
                      color: "#979A9F",
                      textAlign: "left",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    Log out
                  </button>
                </div>
              </Col>

              {/* Main Content */}
              <Col lg={9}>
                {activeSection === "overview" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      My Account
                    </h4>
                    <Row>
                      <Col
                        lg={12}
                        style={{
                          backgroundColor: "#191E27",
                          padding: "30px",
                          minHeight: "200px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <h6
                              style={{ color: "#F4F3F2", marginBottom: "10px" }}
                            >
                              Account Information
                            </h6>
                            <p style={{ color: "#979A9F", fontSize: "12px" }}>
                              Manage your account details
                            </p>
                          </div>
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#2C2D2F",
                            }}
                          ></div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {activeSection === "security" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      Security info
                    </h4>
                    <Row>
                      <Col lg={4}>
                        <div
                          style={{
                            backgroundColor: "#191E27",
                            padding: "30px",
                            textAlign: "center",
                            minHeight: "220px",
                          }}
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#2C2D2F",
                              margin: "0 auto 15px",
                            }}
                          ></div>
                          <h6
                            style={{ color: "#F4F3F2", marginBottom: "10px" }}
                          >
                            Verification Methods
                          </h6>
                          <p
                            style={{
                              color: "#979A9F",
                              fontSize: "12px",
                              marginBottom: "15px",
                            }}
                          >
                            Keep your verification methods and security info up
                            to date.
                          </p>
                          <a
                            href="#"
                            style={{
                              color: "#FD9F29",
                              fontSize: "12px",
                              textDecoration: "none",
                            }}
                          >
                            UPDATE INFO ›
                          </a>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          style={{
                            backgroundColor: "#191E27",
                            padding: "30px",
                            textAlign: "center",
                            minHeight: "220px",
                          }}
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#2C2D2F",
                              margin: "0 auto 15px",
                            }}
                          ></div>
                          <h6
                            style={{ color: "#F4F3F2", marginBottom: "10px" }}
                          >
                            Active Sessions
                          </h6>
                          <p
                            style={{
                              color: "#979A9F",
                              fontSize: "12px",
                              marginBottom: "15px",
                            }}
                          >
                            Review your active sessions and sign out if needed.
                          </p>
                          <a
                            href="#"
                            style={{
                              color: "#FD9F29",
                              fontSize: "12px",
                              textDecoration: "none",
                            }}
                          >
                            MANAGE SESSIONS ›
                          </a>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          style={{
                            backgroundColor: "#191E27",
                            padding: "30px",
                            textAlign: "center",
                            minHeight: "220px",
                          }}
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#2C2D2F",
                              margin: "0 auto 15px",
                            }}
                          ></div>
                          <h6
                            style={{ color: "#F4F3F2", marginBottom: "10px" }}
                          >
                            Login Activity
                          </h6>
                          <p
                            style={{
                              color: "#979A9F",
                              fontSize: "12px",
                              marginBottom: "15px",
                            }}
                          >
                            See when and where you've signed in.
                          </p>
                          <a
                            href="#"
                            style={{
                              color: "#FD9F29",
                              fontSize: "12px",
                              textDecoration: "none",
                            }}
                          >
                            VIEW ACTIVITY ›
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {activeSection === "password" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      Change password
                    </h4>
                    <div
                      style={{
                        backgroundColor: "#191E27",
                        padding: "30px",
                        minHeight: "300px",
                      }}
                    >
                      <h6 style={{ color: "#F4F3F2", marginBottom: "20px" }}>
                        Update Your Password
                      </h6>
                      <p style={{ color: "#979A9F", fontSize: "12px" }}>
                        Make your password stronger, or change it if someone
                        else knows it.
                      </p>
                    </div>
                  </div>
                )}

                {activeSection === "devices" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      Devices
                    </h4>
                    <Row>
                      <Col lg={4}>
                        <div
                          style={{
                            backgroundColor: "#191E27",
                            padding: "30px",
                            textAlign: "center",
                            minHeight: "220px",
                          }}
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#2C2D2F",
                              margin: "0 auto 15px",
                            }}
                          ></div>
                          <h6
                            style={{ color: "#F4F3F2", marginBottom: "10px" }}
                          >
                            Manage Devices
                          </h6>
                          <p
                            style={{
                              color: "#979A9F",
                              fontSize: "12px",
                              marginBottom: "15px",
                            }}
                          >
                            Disable a lost device and review your connected
                            devices.
                          </p>
                          <a
                            href="#"
                            style={{
                              color: "#FD9F29",
                              fontSize: "12px",
                              textDecoration: "none",
                            }}
                          >
                            MANAGE DEVICES ›
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {activeSection === "organizations" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      Organizations
                    </h4>
                    <Row>
                      <Col lg={4}>
                        <div
                          style={{
                            backgroundColor: "#191E27",
                            padding: "30px",
                            textAlign: "center",
                            minHeight: "220px",
                          }}
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              backgroundColor: "#2C2D2F",
                              margin: "0 auto 15px",
                            }}
                          ></div>
                          <h6
                            style={{ color: "#F4F3F2", marginBottom: "10px" }}
                          >
                            Your Organizations
                          </h6>
                          <p
                            style={{
                              color: "#979A9F",
                              fontSize: "12px",
                              marginBottom: "15px",
                            }}
                          >
                            See all the organizations that you're a part of.
                          </p>
                          <a
                            href="#"
                            style={{
                              color: "#FD9F29",
                              fontSize: "12px",
                              textDecoration: "none",
                            }}
                          >
                            MANAGE ORGANIZATIONS ›
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {activeSection === "settings" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      Settings & Privacy
                    </h4>
                    <div
                      style={{
                        backgroundColor: "#191E27",
                        padding: "30px",
                        minHeight: "300px",
                      }}
                    >
                      <h6 style={{ color: "#F4F3F2", marginBottom: "20px" }}>
                        Account Settings
                      </h6>
                      <p style={{ color: "#979A9F", fontSize: "12px" }}>
                        Personalize your account settings and see how your data
                        is used.
                      </p>
                    </div>
                  </div>
                )}

                {activeSection === "activity" && (
                  <div>
                    <h4 style={{ color: "#FD9F29", marginBottom: "15px" }}>
                      Recent activity
                    </h4>
                    <div
                      style={{
                        backgroundColor: "#191E27",
                        padding: "30px",
                        minHeight: "300px",
                      }}
                    >
                      <h6 style={{ color: "#F4F3F2", marginBottom: "20px" }}>
                        Your Activity
                      </h6>
                      <p style={{ color: "#979A9F", fontSize: "12px" }}>
                        See when and where you've signed in and check if
                        anything looks unusual.
                      </p>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </main>
      </div>
    </>
  );
};

export default Profile;
